import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import es from "./locales/es.json";
import nl from "./locales/nl.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import da from "./locales/da.json";
import fr from "./locales/fr.json";
import ru from "./locales/ru.json";

export const SUPPORTED_LANGS = [
  { code: "es", flag: "🇪🇸" },
  { code: "nl", flag: "🇳🇱" },
  { code: "en", flag: "🇬🇧" },
  { code: "de", flag: "🇩🇪" },
  { code: "da", flag: "🇩🇰" },
  { code: "fr", flag: "🇫🇷" },
  { code: "ru", flag: "🇷🇺" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      nl: { translation: nl },
      en: { translation: en },
      de: { translation: de },
      da: { translation: da },
      fr: { translation: fr },
      ru: { translation: ru },
    },
    fallbackLng: "es",
    supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "doctorsol_lang",
    },
  });

export default i18n;
